import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import Modal from '@/components/modalBase/modalBase'
import { Getter, Action, Mutation } from 'vuex-class'
import { VueTelInput } from 'vue-tel-input'

@Component({
  components: {
    Modal,
    VueTelInput
  }
})
export default class ModalPSE extends Vue {
  @Prop({ default: false }) show!: Boolean
  @Prop({ default: () => ({}) }) formData!: Object

  @Getter getPseBanks
  @Getter getCountry: any
  @Action action_getBankPse
  @Getter getPseInformation
  @Mutation PSE_INFORMATION

  bank = null
  form = {
    full_name: '',
    type_person: '0',
    bank: '',
    doc_type: 'CC',
    doc_number: '',
    email: '',
    cellphone: ''
  }
  optionsType = ['CC', 'CE', 'NIT']
  configInputTel = {
    defaultCountry: "co",
    onlyCountries:['co','mx', 'pe', 'ar', 'bs', 'bb', 'bz', 'bo', 'br', 'ca', 'cl', 'cr', 'cu', 'dm', 'ec', 'sv', 'us', 'gt', 'gy', 'ht', 'jm', 'ni', 'pa', 'py', 'do', 'kn', 'vc', 'lc', 'sr', 'tt', 'uy', 've' ],
    validCharactersOnly: true
  }
  msgError = ''
  errors = []

  async created() {
    await this.action_getBankPse()
    this.bank = this.getPseBanks[0]
    this._docNumber()
    if(this.getPseInformation) {
      this.bank = this.getBankByCode(this.getPseInformation.bank);
      this.form = {...this.getPseInformation};
    }

  }

  @Watch('show')
  fillBlankSpaces() {
    if (
      this.form &&
      (!this.form.type_person ||
        (this.form.type_person && this.form.type_person != "1" && this.form.type_person != "0"))
    ) {
      this.form.type_person = "0";
    }
  }

  getBankByCode(bankCode) {
    let response = this.getPseBanks[0];
    this.getPseBanks.forEach((item) => {
      if(item.bankCode == bankCode) {
        response = item;
      }
    });
    return response;
  }

  @Watch('show')
  onShow (val) {
    const formData = (this.formData as any) && (this.formData as any).full_name
    if (val && formData) {
      this.form = (this.formData as any)
    }
  }

  get isMx () {
    return this.getCountry.country_code === 'mx'
  }

  _docNumber() {
    let country_code = ''
    if (this.isMx) {
      country_code = '1012' + Math.round(Math.random() * 999999)
    }
    this.form.doc_number = country_code
  }

  _selectCellphone (number, isValid, country) {
    if (isValid.valid) {
      this.msgError = ''
      const cellphone = isValid.number.e164.replace(/[.*+?^${}()|\s\-[\]\\]/g, '')
      this.form.cellphone = cellphone
    } else {
      this.msgError = 'Por favor escribir un número valido'
    }
  }

  _validate () {
    let errors = []
    if (!this.bank || this.bank.bankCode === '0') {
      errors.push('Banco obligatorio')
    }
    this.errors = errors
    return !errors.length
  }

  _bank (e) {
    this.form.bank = e.bankCode
  }

  _save () {
    if (this._validate()) {
      this.PSE_INFORMATION(this.form);
      this.$emit('info', this.form);
    }
  }

  closeModal () {
  }
}
